import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CommonContext } from './context/commonContext'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'
import { CenterDropdownData, CenterDropdownProps } from '../../types/common'
import { MultiSelect } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'


const CenterDropdown = (props: CenterDropdownProps) => {
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation();
    const [centerId, setCenterId] = useState<string>('')
    const [centerIds, setCenterIds] = useState<string[]>()
    const [centers, setCenters] = useState<CenterDropdownData[]>()
    const findCorps = useCallback(async () => {
        const data = await $http().get('/center-if/centers')
        const filterData = props.includeDel ? data : data.filter((d: any) => d.delYn === 'N')

        if (props.includeAll && props.type && props.type === 'single') {
            filterData.unshift({
                centerId: '',
                centerNm: t(tokens.common.total),
            })
        }

        if (props.includeDel) {
            setCenters(filterData)
        } else {
            setCenters(filterData)
        }
    }, [$http, props.includeAll, props.type, props.includeDel])

    useEffect(() => {
        findCorps()
    }, [$http, findCorps])

    // const findColor = (status: string) => {
    //     return status === 'USE' ? 'rdms-text-success' : 'rdms-text-danger'
    // }

    const itemTemplate = (item: CenterDropdownData) => {
        return (
            <div>
                <span>{item.centerNm}</span>
                {/*<span className={`ml-2 ${findColor(item.corpStatusCd)}`}>({item.corpStatusNm})</span>*/}
            </div>
        )
    }

    const onChangeCenter = (e: DropdownChangeEvent) => {
        if (props.type && props.type === 'multiple') {
            setCenterIds(e.value)
        } else {
            setCenterId(e.value)
        }

        props.onChange && props.onChange(e.value)
    }

    useEffect(() => {
        // console.log('props.value', props.value)
        if (props.value) {
            props?.type === 'multiple' ? setCenterIds(props.value as string[]) : setCenterId(props.value as string)
        }
    }, [props.value, props?.type])

    return (
        <>
            {props.type && props.type === 'multiple' ? (
                <MultiSelect
                    id={props.id||'centerId'}
                    className="p-multiselect-sm"
                    optionLabel="centerNm"
                    optionValue="centerId"
                    value={centerIds}
                    options={centers}
                    onChange={onChangeCenter}
                    itemTemplate={itemTemplate}
                    style={{ width: props && props.width ? props.width : '' }}
                    placeholder={props.placeholder ? props.placeholder : t(tokens.common.choose_center)}
                />
            ) : (
                <Dropdown
                    id={props.id||'centerId'}
                    className="p-inputtext-sm"
                    optionLabel="centerNm"
                    optionValue="centerId"
                    value={centerId}
                    options={centers}
                    onChange={onChangeCenter}
                    itemTemplate={itemTemplate}
                    style={{ width: props && props.width ? props.width : '' }}
                    placeholder={props.placeholder ? props.placeholder : t(tokens.common.choose_center)}
                />
            )}
        </>
    )
}

export default CenterDropdown
